export default __webpack_public_path__ + "i18n/translations/translation-en.5d3ddd11.json";